export default class ImagePopup {
    constructor(selector = '.image-popup') {
        const els = document.querySelectorAll(selector);
        if (!els.length) return;

        this.setupLightbox();

        els.forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const src = el.getAttribute('href');
                this.open(src);
            });
        });
    }

    setupLightbox() {
        // Create overlay
        this.overlay = document.createElement('div');
        this.overlay.style.cssText = `
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.8);
            display: none;
            justify-content: center;
            align-items: center;
            cursor: zoom-out;
            z-index: 9999;
        `;

        // Create image element
        this.img = document.createElement('img');
        this.img.style.cssText = `
            max-width: 90%;
            max-height: 90%;
            cursor: auto;
            border-radius: 4px;
            box-shadow: 0 0 20px rgba(0,0,0,0.4);
        `;

        this.overlay.appendChild(this.img);
        document.body.appendChild(this.overlay);

        // Close when clicking outside the image
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) {
                this.close();
            }
        });
    }

    open(src) {
        this.img.src = src;
        this.overlay.style.display = 'flex';
    }

    close() {
        this.overlay.style.display = 'none';
        this.img.src = '';
    }
}
